/**
 * Attaky Product Card - Color swatch rendering & Add to Cart interaction
 */
var AttakyVariantResolver = window.AttakyVariantResolver || {
  optionsFromVariant: function(variant) {
    var options = {};
    if (!variant) return options;
    [1, 2, 3].forEach(function(position) {
      var value = variant['option' + position];
      if (value != null) options[position] = value;
    });
    return options;
  },

  findVariant: function(variants, selectedOptions) {
    return (variants || []).find(function(variant) {
      return Object.keys(selectedOptions || {}).every(function(position) {
        var actual = variant['option' + position] || '';
        var expected = selectedOptions[position] || '';
        return actual.toLowerCase() === expected.toLowerCase();
      });
    }) || null;
  },

  selectOption: function(variants, currentVariant, position, value) {
    var selectedOptions = this.optionsFromVariant(currentVariant || (variants || [])[0]);
    selectedOptions[position] = value;
    return this.findVariant(variants, selectedOptions);
  },

  isOptionAvailable: function(variants, currentVariant, position, value) {
    var variant = this.selectOption(variants, currentVariant, position, value);
    return Boolean(variant && variant.available);
  }
};
window.AttakyVariantResolver = AttakyVariantResolver;

var AttakyMoneyFormatter = window.AttakyMoneyFormatter || {
  create: function(moneyFormat) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatMatch = typeof moneyFormat === 'string' ? moneyFormat.match(placeholderRegex) : null;
    var formats = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ',']
    };
    var formatOptions = formatMatch ? formats[formatMatch[1]] : null;
    if (!formatOptions) return null;

    return function(cents) {
      if (typeof cents !== 'number' || !Number.isFinite(cents)) return null;
      var parts = (cents / 100).toFixed(formatOptions[0]).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, formatOptions[1]);
      var value = parts[1] ? whole + formatOptions[2] + parts[1] : whole;
      return moneyFormat.replace(placeholderRegex, value);
    };
  }
};
window.AttakyMoneyFormatter = AttakyMoneyFormatter;

(function() {
  'use strict';

  // Guard against duplicate registration when multiple sections include this script
  if (window._attakyProductCardInit) return;
  window._attakyProductCardInit = true;

  function initProductCards() {
    var swatchContainers = document.querySelectorAll('[data-product-card-swatches]');

    swatchContainers.forEach(function(container) {
      var colorValues = JSON.parse(container.getAttribute('data-color-values') || '[]');
      var variants = JSON.parse(container.getAttribute('data-variants') || '[]');
      var selectedColor = container.getAttribute('data-selected-color') || '';
      var variantColorsFromMeta = JSON.parse(container.getAttribute('data-variant-colors') || 'null');
      var colorOptionPosition = parseInt(container.getAttribute('data-color-option-position'), 10) || 1;
      var moneyFormatter = AttakyMoneyFormatter.create(
        container.getAttribute('data-money-format') || ''
      );

      if (typeof AttakyPresetUtils === 'undefined' || colorValues.length === 0) return;

      var card = container.closest('.product-card') || container.closest('.product-detail__info');
      var form = card ? card.querySelector('[data-product-form]') : null;
      var variantInput = form ? form.querySelector('[data-variant-id]') : null;
      var optionButtons = card ? card.querySelectorAll('[data-product-option-position]') : [];
      var isProductDetail = Boolean(card && card.classList.contains('product-detail__info'));
      var restockEntry = card ? card.querySelector('[data-restock-entry]') : null;
      var shippingNotice = card ? card.querySelector('[data-shipping-notice]') : null;

      function formatPrice(cents) {
        return moneyFormatter ? moneyFormatter(cents) : null;
      }

      function updateShippingNotice() {
        if (!shippingNotice) return;
        var normalizedColor = selectedColor.toLowerCase();
        var value = '';
        if (selectedColor === 'Ceramic White') {
          value = shippingNotice.getAttribute('data-ceramic') || '';
        } else if (normalizedColor === 'studio config' || normalizedColor.indexOf('lab access') !== -1) {
          value = shippingNotice.getAttribute('data-custom') || '';
        } else {
          value = shippingNotice.getAttribute('data-other') || '';
        }
        shippingNotice.textContent = value;
        shippingNotice.hidden = !value;
      }

      function currentVariant() {
        var currentId = variantInput ? parseInt(variantInput.value, 10) : 0;
        return variants.find(function(variant) { return variant.id === currentId; }) || variants[0] || null;
      }

      function updateOptionButtons(variant) {
        optionButtons.forEach(function(button) {
          var position = parseInt(button.getAttribute('data-product-option-position'), 10);
          var value = button.getAttribute('data-product-option-value');
          var isActive = Boolean(variant && variant['option' + position] === value);
          button.classList.toggle('active', isActive);
          button.classList.toggle('btn--primary', isActive);
          button.classList.toggle('btn--outline', !isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          button.disabled = !isProductDetail && !AttakyVariantResolver.isOptionAvailable(
            variants,
            variant,
            position,
            value
          );
        });
      }

      function applyVariant(matchedVariant) {
        if (!form || !matchedVariant) {
          if (AttakyPresetUtils.syncBuildVariant) {
            AttakyPresetUtils.syncBuildVariant(container, null);
          }
          var unavailableButton = form ? form.querySelector('[data-add-to-cart]') : null;
          if (unavailableButton) {
            unavailableButton.disabled = true;
            unavailableButton.innerHTML = 'Unavailable';
          }
          if (restockEntry) restockEntry.hidden = true;
          return;
        }

        var themeInput = form.querySelector('[data-selected-theme]');
        var previousVariantId = variantInput ? parseInt(variantInput.value, 10) : 0;
        if (variantInput) {
          variantInput.value = matchedVariant.id;
          if (previousVariantId !== matchedVariant.id) {
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (themeInput) themeInput.value = selectedColor;
        updateShippingNotice();

        updateOptionButtons(matchedVariant);
        if (AttakyPresetUtils.syncBuildVariant) {
          AttakyPresetUtils.syncBuildVariant(container, matchedVariant.id);
        }

        // Update low stock bar visibility (product detail page)
        if (typeof window.updateLowStock === 'function') {
          window.updateLowStock(matchedVariant.id);
        }

        // Update price display (product detail page)
        var priceEl = card ? card.querySelector('.product-detail__price') : null;
        var currentPrice = formatPrice(matchedVariant.price);
        var comparePrice = formatPrice(matchedVariant.compare_at_price);
        if (priceEl && currentPrice) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            priceEl.innerHTML = '<s class="product-detail__price-compare">' + comparePrice + '</s><span class="text-primary">' + currentPrice + '</span><span class="product-detail__sale-badge">SALE</span>';
          } else {
            priceEl.innerHTML = '<span class="text-primary">' + currentPrice + '</span>';
          }
        }

        // Update price display (product card)
        var cardPriceEl = card ? card.querySelector('.card__price') : null;
        if (cardPriceEl && currentPrice) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            cardPriceEl.innerHTML = '<span class="card__price-compare">' + comparePrice + '</span><span class="card__price-sale">' + currentPrice + '</span>';
          } else {
            cardPriceEl.innerHTML = currentPrice;
          }
        }

        // Switch product detail main image to variant's featured image
        if (card && card.classList.contains('product-detail__info')) {
          var detailImg = document.getElementById('product-main-img');
          if (detailImg && matchedVariant.featured_image && matchedVariant.featured_image.src) {
            if (typeof window.preloadAndSwitch === 'function') {
              window.preloadAndSwitch(matchedVariant.featured_image.src);
            } else {
              detailImg.src = matchedVariant.featured_image.src;
            }
            var allThumbs = document.querySelectorAll('.product-detail__thumb');
            allThumbs.forEach(function(thumb) { thumb.classList.remove('active'); });
          }
        }

        // Update button state based on variant availability
        var addButton = form.querySelector('[data-add-to-cart]');
        if (addButton) {
          if (matchedVariant.available) {
            addButton.disabled = false;
            addButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:0.5rem"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart';
          } else {
            addButton.disabled = true;
            addButton.innerHTML = 'Sold Out';
          }
        }
        if (restockEntry) {
          restockEntry.hidden = Boolean(matchedVariant.available);
        }
      }

      function onSelectColor(presetId) {
        selectedColor = presetId;
        container.setAttribute('data-selected-color', presetId);
        var matchedVariant = AttakyVariantResolver.selectOption(
          variants,
          currentVariant(),
          colorOptionPosition,
          presetId
        );
        applyVariant(matchedVariant);

        // Re-render swatches with new selection
        AttakyPresetUtils.renderColorSwatches(container, colorValues, onSelectColor, selectedColor, variantColorsFromMeta);
        if (matchedVariant && AttakyPresetUtils.syncBuildVariant) {
          AttakyPresetUtils.syncBuildVariant(container, matchedVariant.id);
        }
      }

      // Initial render
      AttakyPresetUtils.renderColorSwatches(container, colorValues, onSelectColor, selectedColor, variantColorsFromMeta);
      var initialVariant = currentVariant();
      updateOptionButtons(initialVariant);
      updateShippingNotice();
      if (initialVariant && AttakyPresetUtils.syncBuildVariant) {
        AttakyPresetUtils.syncBuildVariant(container, initialVariant.id);
      }

      optionButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          var position = parseInt(button.getAttribute('data-product-option-position'), 10);
          var value = button.getAttribute('data-product-option-value');
          var matchedVariant = AttakyVariantResolver.selectOption(
            variants,
            currentVariant(),
            position,
            value
          );
          applyVariant(matchedVariant);
        });
      });
    });

    // Add to Cart AJAX
    var forms = document.querySelectorAll('[data-product-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        if (!btn || btn.disabled) return;

        btn.disabled = true;
        var originalText = btn.innerHTML;
        btn.innerHTML = '<span class="loader" style="margin-right:0.5rem"></span> Adding...';

        var formData = new FormData(form);
        var data = {};
        formData.forEach(function(value, key) {
          data[key] = value;
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(data.id),
            quantity: parseInt(data.quantity || 1),
            properties: data['properties[Theme]'] ? { Theme: data['properties[Theme]'] } : {}
          })
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) {
              var err = new Error(data.description || 'Failed to add to cart');
              err.data = data;
              throw err;
            }
            return data;
          });
        })
        .then(function(item) {
          // Update cart count in header
          updateCartCount();

          // Show toast
          if (window.AttakyToast) {
            window.AttakyToast.show(item.product_title + ' added to cart!', {
              type: 'success',
              action: { label: 'Go to Cart', url: '/cart' }
            });
          }
        })
        .catch(function(error) {
          var msg = error.message || 'Failed to add to cart';
          if (window.AttakyToast) {
            window.AttakyToast.show(msg, { type: 'error' });
          }
        })
        .finally(function() {
          btn.disabled = false;
          btn.innerHTML = originalText;
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEl = document.getElementById('cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            // Create badge
            var cartLink = document.querySelector('.site-header__cart');
            if (cartLink) {
              countEl = document.createElement('span');
              countEl.className = 'site-header__cart-count';
              countEl.id = 'cart-count';
              cartLink.appendChild(countEl);
            }
          }
          if (countEl) {
            countEl.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
          }
        } else if (countEl) {
          countEl.remove();
        }
      })
      .catch(function() {});
  }

  // ── Description expand/collapse (event delegation) ───────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-desc-toggle]');
    if (!btn) return;
    var desc = btn.previousElementSibling;
    if (!desc) return;
    var isExpanded = btn.getAttribute('data-expanded') === 'true';
    isExpanded = !isExpanded;
    btn.setAttribute('data-expanded', isExpanded ? 'true' : 'false');
    desc.textContent = isExpanded ? btn.getAttribute('data-full') : btn.getAttribute('data-short');
    btn.textContent = isExpanded ? 'Show less ▲' : 'Show more ▼';
  });

  // ── Color Selections toggle (event delegation) ────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-color-toggle]');
    if (!btn) return;
    var panel = btn.parentElement && btn.parentElement.querySelector('[data-color-panel]');
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.style.display = open ? 'none' : 'block';
    var arrow = open ? ' ▼' : ' ▲';
    btn.textContent = btn.textContent.trim().replace(/\s*[▼▲]\s*$/, '') + arrow;
  });

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCards);
  } else {
    initProductCards();
  }
})();
